export type CarData = {
    [key: string]: {
        path: string;
        src: string;
        text: string;
    };
};

export type CarPageData = {
    path: string;
    src: string;
    text: string;
};

export let data: CarData = {
    mercedes: {
        path: '/mercedes',
        src: 'https://images.unsplash.com/photo-1666561305159-5198975bbaae?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2815&q=80',
        text: 'mercedes',
    },
    ford: {
        path: '/ford',
        src: 'https://images.unsplash.com/photo-1666460023412-9032385f9569?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2787&q=80',
        text: 'ford',
    },
    bmw: {
        path: '/bmw',
        src: 'https://images.unsplash.com/photo-1672828660910-3e6f3ab4a249?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2903&q=80',
        text: 'bmw',
    },
    cadillac: {
        path: '/cadillac',
        src: 'https://images.unsplash.com/photo-1590880351453-72de6aaf030e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NzR8fHZpbnRhZ2UlMjBjYXJ8ZW58MHwxfDB8fHww&auto=format&fit=crop&w=800&q=60',
        text: 'cadillac',
    },
    porsche: {
        path: '/porsche',
        src: 'https://images.unsplash.com/photo-1661719123161-b78fdbe15785?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=3027&q=80',
        text: 'porsche',
    },
    triumph: {
        path: '/triumph',
        src: 'https://images.unsplash.com/photo-1637085031464-02edb87c48b7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2787&q=80',
        text: 'cadillac',
    },
    golf: {
        path: '/golf',
        src: 'https://images.unsplash.com/photo-1562172395-1ddea5047501?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NTd8fHZpbnRhZ2UlMjBnb2xmJTIwY2FyfGVufDB8fDB8fHww&auto=format&fit=crop&w=800&q=60',
        text: 'golf gti',
    },
    buick: {
        path: '/buick',
        src: 'https://images.unsplash.com/photo-1636066633358-21d2d670c61a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2815&q=80',
        text: 'buick',
    },
    chevrolet: {
        path: '/chevrolet',
        src: 'https://images.unsplash.com/photo-1582816640547-0a4b756ae997?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2940&q=80',
        text: 'chevrolet',
    },
    mustang: {
        path: '/mustang',
        src: 'https://images.unsplash.com/photo-1651833619757-c66ef93498a9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2787&q=80',
        text: 'ford mustang',
    },
    mustangTwo: {
        path: '/mustang-two',
        src: 'https://images.unsplash.com/photo-1567608904117-f10d8048951d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2865&q=80',
        text: 'ford mustang',
    },
    porscheTwo: {
        path: '/porsche-two',
        src: 'https://images.unsplash.com/photo-1639590071606-4c6559f3297c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2787&q=80',
        text: 'porsche',
    },
    mercedesTwo: {
        path: '/mercedes-two',
        src: 'https://images.unsplash.com/photo-1625648304729-0e318311bb5c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2940&q=80',
        text: 'mercedes',
    },
    tire: {
        path: '/tire',
        src: 'https://images.unsplash.com/photo-1630583699879-56eb2e799917?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2874&q=80',
        text: 'tire',
    },
    bmwTwo: {
        path: '/bmw-two',
        src: 'https://images.unsplash.com/photo-1535993482186-9f5cd587a74c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2787&q=80',
        text: 'bmw',
    },
    chevroletTwo: {
        path: '/chevrolet-two',
        src: 'https://images.unsplash.com/photo-1591020335087-8b35909799b8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2940&q=80',
        text: 'chevrolet',
    },
    chevroletThree: {
        path: '/chevrolet-three',
        src: 'https://images.unsplash.com/photo-1581288655242-9948908a9d71?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2950&q=80',
        text: 'chevrolet corvair',
    },
    classic: {
        path: '/classic-car',
        src: 'https://images.unsplash.com/photo-1581288755182-669e268b5a62?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2950&q=80',
        text: 'classic car',
    },
    porscheThree: {
        path: '/porsche-three',
        src: 'https://images.unsplash.com/photo-1584749508056-69cf9778efcd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2950&q=80',
        text: 'porsche',
    },
    classicTwo: {
        path: '/classic-two',
        src: 'https://images.unsplash.com/photo-1590522427073-1afdcb897df3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2048&q=80',
        text: 'classic car',
    },
    chevroletFour: {
        path: '/chevrolet-four',
        src: 'https://images.unsplash.com/photo-1590177137677-48a912983a35?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2048&q=80',
        text: 'Chevrolet',
    },
    astonMartin: {
        path: '/aston-martin',
        src: 'https://images.unsplash.com/photo-1641035856228-11b386f64d4d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2940&q=80',
        text: 'aston martin',
    },
    lamborghini: {
        path: '/lamborghini',
        src: 'https://images.unsplash.com/photo-1683969234355-e090745310a9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NTN8fGxhbWJvcmdoaW5pJTIwY291bnRhY2h8ZW58MHwxfDB8fHww&auto=format&fit=crop&w=800&q=60',
        text: 'lamborghini countach',
    },
    lancia: {
        path: '/lancia',
        src: 'https://images.unsplash.com/photo-1532601194588-11ec1d596a35?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjE3fHxub2lyJTIwYmxhbmMlMjB2b2l0dXJlfGVufDB8fDB8fHww&auto=format&fit=crop&w=800&q=60',
        text: 'lancia',
    },
    ferrari: {
        path: '/ferrari',
        src: 'https://images.unsplash.com/photo-1634891268288-0a1b8473f27b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=3027&q=80',
        text: 'ferrari testarossa',
    },
    golfGti: {
        path: '/golf-gti',
        src: 'https://images.unsplash.com/photo-1596133566962-53037e91c09f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=3870&q=80',
        text: 'golf 2 gti',
    },
    ferrariTwo: {
        path: '/ferrari-two',
        src: 'https://images.unsplash.com/photo-1692931460185-5cd8cee9ba8c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=3870&q=80',
        text: 'ferrari f40',
    },
    lamborghiniTwo: {
        path: '/lamborghini-two',
        src: 'https://images.unsplash.com/photo-1660862003821-59b9dec188f0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTd8fGxhbWJvcmdoaW5pJTIwZGlhYmxvfGVufDB8fDB8fHww&auto=format&fit=crop&w=800&q=60',
        text: 'lamborghini diablo',
    },
    corvette: {
        path: '/corvette',
        src: 'https://images.unsplash.com/photo-1604323847852-bf1f2c2971a7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=3870&q=80',
        text: 'chevrolet corvette',
    },
    subaru: {
        path: '/subaru',
        src: 'https://images.unsplash.com/photo-1570730341517-278d47ab7ca1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8aW1wcmV6YXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=800&q=60',
        text: 'subaru impreza',
    },
    dodgeCharger: {
        path: '/dodge-charger',
        src: 'https://images.unsplash.com/photo-1562911786-e9d112ad735a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2940&q=80',
        text: 'dodge charger',
    },
    fordTasca: {
        path: '/ford-tasca',
        src: 'https://images.unsplash.com/photo-1565968121242-62b217ff5404?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDE5fHx8ZW58MHx8fHx8&auto=format&fit=crop&w=800&q=60',
        text: 'ford tasca',
    },
    mini: {
        path: '/mini',
        src: 'https://images.unsplash.com/photo-1619880839324-3fe7b84c5e5f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=3774&q=80',
        text: 'mini cooper',
    },
    coccinelle: {
        path: '/coccinelle',
        src: 'https://images.unsplash.com/photo-1536168483275-f5736f5c844b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8dmludGFnZSUyMGNhcnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=800&q=60',
        text: 'coccinelle',
    },
    continental: {
        path: '/continental',
        src: 'https://images.unsplash.com/photo-1577076956766-5345e1183d33?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=3774&q=80',
        text: 'continental',
    },
    jaguar: {
        path: '/jaguar',
        src: 'https://images.unsplash.com/photo-1488610883421-64eb350d7f12?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=3915&q=80',
        text: 'jaguar',
    },
};
